import type { FormRenderProps } from "@tql/ui-components-react/kendo/form";

export const ERROR_STOP_BADGE_CLASS_NAME =
	"k-text-error k-border-solid k-border-error k-border-2 k-px-2 k-py-0.5";
export const SUCCESS_STOP_BADGE_CLASS_NAME =
	"k-text-success k-border-solid k-border-success k-border-2 k-px-2 k-py-0.5";

export const SHIPPER_RECEIVER_NAME_MAX_LENGTH = 50;
// 100 is the width of the downstream Tender table column
// (tblTraxTenderALoadStopData.StopAddress). The Quote table column is wider
// (250), but this step tenders the quote, so the narrower limit applies.
export const STREET_ADDRESS_MAX_LENGTH = 100;
export const DELIVERY_PICKUP_NUMBER_MAX_LENGTH = 50;
export const MAX_APPOINTMENT_INFO_LENGTH = 200;

export function shipperNameValidator(value: string): string {
	if (value == undefined || value == null || value.trim() === "") {
		return "Shipper Name is required.";
	}
	if (value.length > SHIPPER_RECEIVER_NAME_MAX_LENGTH) {
		return `Shipper Name cannot exceed ${SHIPPER_RECEIVER_NAME_MAX_LENGTH} characters.`;
	}
	return "";
}

export function receiverNameValidator(value: string): string {
	if (value == undefined || value == null || value.trim() === "") {
		return "Receiver Name is required.";
	}
	if (value.length > SHIPPER_RECEIVER_NAME_MAX_LENGTH) {
		return `Receiver Name cannot exceed ${SHIPPER_RECEIVER_NAME_MAX_LENGTH} characters.`;
	}
	return "";
}

export function streetAddressValidator(value: string): string {
	if (value == undefined || value == null || value.trim() === "") {
		return "Street Address is required.";
	}
	if (value.length > STREET_ADDRESS_MAX_LENGTH) {
		return `Street Address cannot exceed ${STREET_ADDRESS_MAX_LENGTH} characters.`;
	}
	return "";
}

export function pickupNumberValidator(value: string | undefined): string {
	if (value && value.length > DELIVERY_PICKUP_NUMBER_MAX_LENGTH) {
		return `Pickup Number cannot exceed ${DELIVERY_PICKUP_NUMBER_MAX_LENGTH} characters.`;
	}
	return "";
}

export function deliveryPONumberValidator(value: string | undefined): string {
	if (value && value.length > DELIVERY_PICKUP_NUMBER_MAX_LENGTH) {
		return `Delivery PO Number cannot exceed ${DELIVERY_PICKUP_NUMBER_MAX_LENGTH} characters.`;
	}
	return "";
}

export function appointmentInformationValidator(
	value: string | undefined,
): string {
	if (value && value.length > MAX_APPOINTMENT_INFO_LENGTH) {
		return `Appointment Information cannot exceed ${MAX_APPOINTMENT_INFO_LENGTH} characters.`;
	}
	return "";
}

export function validateStopDetail(value: string): boolean {
	return value != undefined && value != null && value.trim() !== "";
}

function isWithinMaxLength(value: unknown, maxLength: number): boolean {
	return typeof value !== "string" || value.length <= maxLength;
}

export function hasValidStopDetails(
	formRenderProps: FormRenderProps,
	stopIndex: number,
): boolean {
	const locationName = formRenderProps.valueGetter(
		`stops[${stopIndex}].locationName`,
	) as string;
	const streetAddress = formRenderProps.valueGetter(
		`stops[${stopIndex}].streetAddress`,
	) as string;

	const referenceNumber: unknown = formRenderProps.valueGetter(
		`stops[${stopIndex}].referenceNumber`,
	);
	const appointmentInformation: unknown = formRenderProps.valueGetter(
		`stops[${stopIndex}].appointmentInformation`,
	);

	return (
		validateStopDetail(locationName) &&
		validateStopDetail(streetAddress) &&
		isWithinMaxLength(locationName, SHIPPER_RECEIVER_NAME_MAX_LENGTH) &&
		isWithinMaxLength(streetAddress, STREET_ADDRESS_MAX_LENGTH) &&
		isWithinMaxLength(referenceNumber, DELIVERY_PICKUP_NUMBER_MAX_LENGTH) &&
		isWithinMaxLength(appointmentInformation, MAX_APPOINTMENT_INFO_LENGTH)
	);
}

export function getStopBadgeClassName(
	formRenderProps: FormRenderProps,
	stopIndex: number,
	hasSubmitted: boolean,
): string | undefined {
	if (hasValidStopDetails(formRenderProps, stopIndex)) {
		return SUCCESS_STOP_BADGE_CLASS_NAME;
	}
	if (hasSubmitted) {
		return ERROR_STOP_BADGE_CLASS_NAME;
	}
	return undefined;
}
